import Moment from "react-moment";
import { useNavigate } from "react-router-dom";

function JobListItem(props) {
  const navigate = useNavigate();
  const handleApplyNow = (job) => {
    navigate(`/job-detail/${job.jobid}`);
  };
  return (
    <>
      {props.jobs.length > 0 ? (
        <>
          {props.jobs.map((job, index) => (
            <div className="job-item p-4 mb-4" key={index}>
              <div className="row g-4">
                <div className="col-sm-12 col-md-8 d-flex align-items-center">
                  <img
                    className="flex-shrink-0 img-fluid border rounded"
                    src={`https://picsum.photos/seed/${Math.random()}/80`}
                    alt=""
                    style={{ width: "80px", height: "80px" }}
                  />
                  <div className="text-start ps-4">
                    <h5 className="mb-3">{job.title}</h5>
                    <span className="text-truncate me-3">
                      <i className="fa fa-map-marker-alt text-primary me-2"></i>
                      {job.location}
                    </span>
                    <span className="text-truncate me-3">
                      <i className="far fa-clock text-primary me-2"></i>
                      {job.jobNature}
                    </span>
                    <span className="text-truncate me-0">
                      <i className="far fa-money-bill-alt text-primary me-2"></i>
                      {job.salary}
                    </span>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4 d-flex flex-column align-items-start align-items-md-end justify-content-center">
                  <div className="d-flex mb-3">
                    <a className="btn btn-light btn-square me-3" href="/">
                      <i className="far fa-heart text-primary"></i>
                    </a>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleApplyNow(job)}
                    >
                      Apply Now
                    </button>
                  </div>
                  <small className="text-truncate">
                    <i className="far fa-calendar-alt text-primary me-2"></i>
                    Date Line:{" "}
                    <Moment format="D MMM YYYY" withTitle>
                      {job.publishedDate}
                    </Moment>
                  </small>
                </div>
              </div>
            </div>
          ))}
        </>
      ) : (
        <div className="job-item p-4 mb-4">
          <div className="row g-4">
            <p className="d-flex">No results found. Plese try again later.</p>
          </div>
        </div>
      )}
    </>
  );
}

export default JobListItem;
